// extracted by mini-css-extract-plugin
export default {"tableContainer":"usersList_tableContainer__oNGfB"};